import { TextField } from "@mui/material";

import { ALLOWED_YEARS_INPUT_REGEX } from "../types";

interface AllowedYearsRuleFieldsProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Field for *_ALLOWED_YEARS rules: a comma-separated list of 4-digit years.
 */
export function AllowedYearsRuleFields({ value, onChange }: AllowedYearsRuleFieldsProps) {
  const showError = value.trim().length > 0 && !ALLOWED_YEARS_INPUT_REGEX.test(value.trim());
  return (
    <TextField
      fullWidth
      label="Allowed Reporting Years"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="2025,2026"
      error={showError}
      helperText={
        showError
          ? "Enter a comma-separated list of 4-digit years (e.g. 2025,2026)"
          : "Comma-separated list of 4-digit years"
      }
    />
  );
}
